export const MESSAGE_TYPE = {
  email: 'email',
  sms: 'sms',
};

export const MESSAGE_DIRECTION = {
  receiving: 'ingress',
  sending: 'egress',
};
